export const HIGHSCORE__ANIMALS_IN_ORDER = ['highscore', 'animals_in_order'];
export const HIGHSCORE__ANIMALS_IN_ORDER_BLIND = ['highscore', 'animals_in_order_blind'];
export const HIGHSCORE__ANIMAL_QUIZ = ['highscore', 'animal_quiz'];
